import { gql } from '@apollo/client'

const ALLOCATE_AUTOMATICALLY_MUTATION = gql`
  mutation allocateAutomaticallyMutation($priorityTaskId: ID!, $time: Int) {
    allocateAutomatically(priorityTaskId: $priorityTaskId, time: $time)
  }
`

export default ALLOCATE_AUTOMATICALLY_MUTATION
